import { imageAssetUrl } from "@/utils/url";
import { useNavigate } from "@tanstack/react-router";
import { Client } from "creso-core/types";
import { Button } from "web-design-system";

export function ProposalsEmpty({ client }: { client: Client }) {
  const navigate = useNavigate();

  return (
    <div className="flex-1 rounded-lg gap-20 border border-border bg-card flex items-center w-full">
      <div className="flex-1 items-center justify-center flex">
        <div className="h-50 w-70 bg-card">
          <img
            className="aspect-auto"
            src={imageAssetUrl("/proposals/proposals-empty.png")}
          />
        </div>
      </div>
      <div className="flex-1 items-start justify-center flex flex-col">
        <span className="text-xl font-semibold">Proposal</span>
        <span className="mt-2 text-muted-foreground">
          Create a branded pitch of your recommendations
        </span>
        <Button
          onClick={() =>
            navigate({
              to: ".",
              search: {
                client_id: client.id,
                modal: "proposal" as const,
                state: "init",
              },
            })
          }
          size="lg"
          className="mt-12"
          variant="outline"
        >
          Create Proposal
        </Button>
      </div>
    </div>
  );
}
